import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "nba_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-consent-banner"
          className="fixed bottom-20 md:bottom-6 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-2xl"
        >
          <div className="bg-navy text-white rounded-2xl shadow-2xl shadow-navy/40 border border-white/10 p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Cookie size={26} className="text-gold shrink-0" />
            <p className="text-sm text-slate-300 leading-relaxed flex-1">
              This website uses essential cookies and, with your consent, privacy-respecting analytics to improve your experience. Read our{" "}
              <Link to="/cookie-policy" className="text-gold underline underline-offset-2" data-testid="cookie-policy-link">Cookie Policy</Link>.
            </p>
            <div className="flex gap-2.5 shrink-0 w-full sm:w-auto">
              <button
                data-testid="cookie-essential-button"
                onClick={() => accept("essential")}
                className="flex-1 sm:flex-none px-4 py-2.5 rounded-full text-xs font-semibold border border-white/25 hover:bg-white/10 transition-colors"
              >
                Essential Only
              </button>
              <button
                data-testid="cookie-accept-button"
                onClick={() => accept("all")}
                className="flex-1 sm:flex-none px-4 py-2.5 rounded-full text-xs font-semibold bg-gold text-navy hover:bg-gold-bright transition-colors"
              >
                Accept All
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
